import { THEME_TOKEN, Theme } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  selectOptionSelectedStylesSAG,
  selectOptionSelectedStylesSHS,
  selectOptionStylesSAG,
  selectOptionStylesSHS,
  selectionOptionTextStylesSAG,
  selectionOptionTextStylesSHS,
} from './select-options.styles';

@Component({
  selector: 'sag-ui-option',
  templateUrl: './select-option.component.html',
  styleUrls: [],
})
export class OptionComponent {
  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;

  @Input()
  selected = false;

  @Input()
  multiple = false;

  @Input()
  hidden = false;

  @Output()
  // eslint-disable-next-line
  select: EventEmitter<[string, any]> = new EventEmitter();

  @ViewChild('text') text!: ElementRef;

  constructor(@Inject(THEME_TOKEN) private readonly theme: Theme) {}

  protected get containerClasses(): string {
    if (this.hidden) {
      return 'hidden';
    }

    const containerStyles = componentStylesByTheme(
      this.theme,
      selectOptionStylesSAG,
      selectOptionStylesSHS
    );

    const selectedContainerStyles = componentStylesByTheme(
      this.theme,
      selectOptionSelectedStylesSAG,
      selectOptionSelectedStylesSHS
    );

    return this.selected ? selectedContainerStyles() : containerStyles();
  }

  protected get textClasses(): string {
    const textStyles = componentStylesByTheme(
      this.theme,
      selectionOptionTextStylesSAG,
      selectionOptionTextStylesSHS
    );

    return textStyles();
  }

  protected onClick() {
    const innerText = this.text.nativeElement.innerText;
    this.select.emit([innerText, this.value]);
  }

  protected onKeyDown(event: KeyboardEvent): void {
    if (event.code === 'Space') {
      event.preventDefault();
      this.onClick();
      (event.target as HTMLDivElement).focus();
    }
  }
}
